export default __webpack_public_path__ + "static/media/2130.79d75d10.png";